const Footer = {
  handleFooterCategories: function () {
    if ($('body').width() < 1024) {
      $('.menu-footer').each((i, element) => {
        $(element).find('.title-tab').on('click', function (e) {
          e.preventDefault();
          console.log(element)
          console.log($(element).find('.content'))
          $(element).find('.content').toggleClass('open')
          $(this).toggleClass('open')
        })
      })
    }
  },

  init: function () {
    this.handleFooterCategories();
  },
};

export default Footer;
